import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, FormControl, InputLabel, Select, MenuItem, Button, DialogTitle, Box, DialogActions} from '@mui/material';
import './boundCases.css';
import axios from "axios";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import CaseNotificationEnum from "../../enums/CaseNotiFicationEnum";
import {jwtDecode} from "jwt-decode";
import {useLocation} from "react-router-dom";

function ChangeCaseViewerPopup({ open, handleClose, users, caseManager, onUpdate, caseManagers, caseFiles, onFileUpdate, departmentId }) {
    const [selectedUser, setSelectedUser] = useState('');
    const [userModalOpen, setUserModalOpen] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const filesToUpdate = caseFiles.filter(file => file.creatorId === caseManager.toUserId)
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [roleId, setRoleId] = useState('');
    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);
    const sendNotification = async (newUserID) => {
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: newUserID,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: null,
            action: CaseNotificationEnum.addUser.id,
            caseStatus: 8,
            viewed: false,
            newUserID: newUserID,
            oldUserID: caseManager.toUserId

        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    useEffect(() => {
        if (departmentId === "69"){
            const filtered = users.filter(user => !caseManagers.some(cm => cm.toUserId === user.id ) );
            setFilteredUsers(filtered);
        }
        else{
            const filtered = users.filter(user => !caseManagers.some(cm => cm.toUserId === user.id ) && user.departmentId === departmentId);
            setFilteredUsers(filtered);
        }
    }, [users, caseManagers]);

    const rolesInGeorgian = {
        'HeadOfAgency': "სააგენტოს უფროსი",
        'DeputyHeadOfAgency': "უფროსის მოადგილე",
        'HeadOfDepartment': "სამმართველოს უფროსი",
        'Expert': "სპეციალისტი"
    };


    const updateCaseViewer = async () => {
        const body = {
            ...caseManager,
            toUserId: selectedUser
        };
        try {
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseUserAllProperty`, body);
        } catch (error) {
            console.error(error);
        }

        if (filesToUpdate.length > 0) {
            const updatePayload = {
                casefileIds: filesToUpdate.map(file => file.id),
                caseCreatorId: selectedUser
            };
            await axios.put(`${process.env.REACT_APP_API_BASE_URL}/UpdateCaseFileCreatorId`, updatePayload);
        }
        onUpdate();
        await sendNotification(selectedUser)
        onFileUpdate();
        setUserModalOpen(false);
        setSelectedUser("");
        handleClose();
    };

    const handleUserChange = (event) => {
        setSelectedUser(event.target.value);
    };

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={open}
                onClose={handleClose}
                aria-labelledby="change-case-user-dialog-title"
                PaperProps={{
                    style: {
                        borderRadius: '10px',
                        padding: '20px',
                        position: 'relative',
                    }
                }}
            >
                <DialogTitle id="change-case-user-dialog-title">მეორადი შემსრულებლის შეცვლა</DialogTitle>
                <DialogContent>
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="user-select-label">შემსრულებელი</InputLabel>
                        <Select
                            labelId="user-select-label"
                            value={selectedUser}
                            label="შემსრულებელი"
                            onChange={handleUserChange}
                        >
                            {filteredUsers.map((user) => (
                                <MenuItem key={user.id} value={user.id}>
                                    {user.firstName} {user.lastName} ({rolesInGeorgian[user.roleName]})
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <Button onClick={handleClose} color="secondary" variant="outlined">
                            გაუქმება
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setUserModalOpen(true)}
                            disabled={!selectedUser}
                        >
                            დადასტურება
                        </Button>
                    </Box>
                </DialogActions>
                {userModalOpen && (
                    <ConfirmationModal
                        isOpen={userModalOpen}
                        onRequestClose={() => setUserModalOpen(false)}
                        onConfirm={() => {
                            void updateCaseViewer();
                        }}
                    />)}
            </Dialog>
        </>
    );
}

export default ChangeCaseViewerPopup;
